import { Feature } from '@turf/helpers';

export function getClusterGroupName(singleFeaturePoint: Feature) {
  return `${singleFeaturePoint.properties?.dbscan} - ${singleFeaturePoint.properties?.cluster}`;
}
